export default __webpack_public_path__ + "static/media/building.b8b9775c.svg";